import clsx from "clsx";
import { Col, Pagination, Row } from "react-bootstrap";
import MaterialIcon from "react-google-material-icons";
import React, { useState } from "react";
import CloseButton from "react-bootstrap/CloseButton";
import Modal from "react-bootstrap/Modal";
import _ from "lodash";
import * as announcementSelectors from "../../selectors/announcement";
import {
  getAnnouncementDetailContent,
  getAnnouncementDetailUpdatedAtText,
} from "../../selectors/announcement";
import AnnouncementModal from "../../views/Dashboard/modal/AnnouncementModal";
import LoadingOverlay from "../LoadingOverlay";
import EmptyItemView from "../EmptyItemView";

function CustomCardAnnounce({ items, data, loading, page, setPage, isPlaceholderData }) {
  const [showModal, setShowModal] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const meta = _.get(data, ["data", "meta"], null);
  const currentData = _.get(data, ["data", "data"], null);
  const lastPage = _.get(meta, ["last_page"], null);
  const total = _.get(meta, ["total"], 0);
  return (
    <div className="shadow mt-4">
      <div className={clsx("custom-card-label-container d-flex align-items-center")}>
        <MaterialIcon icon="feedback" size={24} />
        <h2>Announcement ({total})</h2>
      </div>
      <div
        className={clsx("custom-card-label-annouce-container position-relative", {
          ["loading-height"]: loading,
        })}
      >
        <div>
          {currentData ? (
            currentData.map((item, index) => {
              const title = announcementSelectors.getAnnouncementDetailTitle(item);
              const updatedAt = announcementSelectors.getAnnouncementDetailUpdatedAtText(item);
              const content = announcementSelectors.getAnnouncementDetailContent(item);

              return (
                <Row key={index}>
                  <Col md={12} lg={12} xl={12} sm={12}>
                    <div
                      onClick={() => {
                        setShowModal(true);
                        setSelectedData(item);
                      }}
                      className={clsx("custom-card-announcement-item-container custom-card-box-shadow")}
                    >
                      <Row>
                        <Col md={12} lg={2} xl={2} sm={12}>
                          <div>
                            <h4>{updatedAt}</h4>
                          </div>
                        </Col>
                        <Col md={12} lg={10} xl={10} sm={12}>
                          <div>
                            <h4>{title}</h4>
                            {/*<h4 dangerouslySetInnerHTML={{ __html: content }}></h4>*/}
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
              );
            })
          ) : (
            <EmptyItemView />
          )}
          {lastPage > 1 ? (
            <Pagination
              className="mt-2"
              onClick={(e) => {
                if (_.toInteger(e.target.text) !== 0 && _.toInteger(e.target.text) !== page) {
                  setPage(_.toInteger(e.target.text));
                }
              }}
            >
              {_.times(lastPage, (index) => {
                return (
                  <Pagination.Item key={index + 1} active={page === index + 1}>
                    {index + 1}
                  </Pagination.Item>
                );
              })}
            </Pagination>
          ) : (
            false
          )}
          <LoadingOverlay loading={data?.data?.loading} loadingClass="loading-height"></LoadingOverlay>
        </div>
        <AnnouncementModal
          showModal={showModal}
          setShowModal={setShowModal}
          item={selectedData}
        ></AnnouncementModal>
      </div>
    </div>
  );
}

export default CustomCardAnnounce;
